class GiftWithPurchase {
    constructor(product, price, type, minimum) {
      this.product = product;
      this.type = type
      this.minimumAmount = minimum
      this.giftApplied = false
      this.price = price
    }
  
    addGiftToCart() {
      console.log("GWP START");
      fetch('/cart.js')
      .then((response) => response.json())
      .then((response) => {
        console.log("RESPONSE", response)
        this.giftApplied = response.items.some(item => item.properties._is_gift_with_purchase === true)
        const minimumPrice = parseInt(this.minimumAmount) * 100
        const cartAmount = response.total_price
        const ajaxCart = document.querySelector('ajax-cart');
        let config = fetchConfig('javascript');
  
        config.body = JSON.stringify(
          {
            "id": this.product,
            "quantity": 1,
            "properties": {
              '_is_gift_with_purchase': true,
              '_gwp_type': this.type
            },
            "sections": ajaxCart.getSectionsToRender().map((section) => section.id),
            "sections_url": window.location.pathname
          }
        );

        if (cartAmount >= minimumPrice && !this.giftApplied) {
          fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
    
            console.log("GWP ADDED");
            this.giftApplied = true
            ajaxCart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          });
        }

        if (this.giftApplied && (cartAmount - this.price < minimumPrice) ) {
          config.body = JSON.stringify(
            {
              "updates": {
                [this.product]: 0
              },
              "sections": ajaxCart.getSectionsToRender().map((section) => section.id),
              "sections_url": window.location.pathname
            }
          ); 
          
          fetch(`${routes.cart_update_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
    
            console.log("GWP REMOVED");
            this.giftApplied = false
            ajaxCart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          });
        }
      })
    }
  }
  